export default __webpack_public_path__ + "static/media/image4-1.4c9be7cd.png";